import { Controller } from "stimulus";

// Makes a table row navigate to data-href when clicked anywhere outside
// an inner <a>, <button> or form control. Used by admin list grids.
export default class extends Controller {
  static values = { href: String };

  connect() {
    this.element.addEventListener('click', this.onClick.bind(this));
  }

  disconnect() {
    this.element.removeEventListener('click', this.onClick.bind(this));
  }

  onClick(event) {
    if (!this.hrefValue) return;
    if (event.target.closest('a, button, input, select, textarea, label, .dropdown')) return;
    window.location.href = this.hrefValue;
  }
};
